module.exports = __webpack_public_path__ + "static/img/help_08book_01.aa81434.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fdback/help_08book_01.jpg
// module id = 702
// module chunks = 140